export const siteInfo = {
  siteName: '每日大赛黑料',
  tagline: '赛事内幕 · 一手爆料 · 每日更新',
  slogan: '吃瓜不等待，黑料趁热来',
  description: '每日大赛黑料专注追踪各类电竞联赛、综艺选秀、娱乐圈大赛的最新内幕与独家爆料。我们以分钟级速度推送黑料动态，从选手私下恩怨到节目组暗箱操作，从票数争议到合约内幕，让你不错过任何一个吃瓜现场。团队7×24小时监控全平台信息源，确保每条黑料都有据可查，持续为你揭开大赛背后的真实面目。当前热门赛道覆盖电竞赛事、偶像选秀、歌手竞演、真人秀综艺四大板块，今日更新已超30条。',
  stats: [
    { label: '今日更新', value: '37条' },
    { label: '覆盖赛道', value: '12个' },
    { label: '全网追踪', value: '24小时' },
  ],
  ctaPrimary: { text: '看最新黑料', href: '#ranking' },
  ctaSecondary: { text: '我要爆料', href: '#contact' },
};

export const navLinks = [
  { text: '首页', href: '#hero' },
  { text: '平台优势', href: '#features' },
  { text: '热门排行', href: '#ranking' },
  { text: '独家爆料', href: '#cards' },
  { text: '吃瓜现场', href: '#comments' },
  { text: '常见问题', href: '#faq' },
  { text: 'APP下载', href: '#app' },
];

export const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '分钟级推送大赛黑料与内幕，全网实时监控，不遗漏任何一个热点动态，让你永远快人一步掌握真相。',
  },
  {
    icon: 'ri-spy-line',
    title: '独家爆料',
    desc: '深度挖掘赛事背后不为人知的内幕，独家信源验证，每一条黑料都经过多方交叉核实，确保信息真实可靠。',
  },
  {
    icon: 'ri-fire-line',
    title: '热度榜单',
    desc: '基于实时讨论热度的科学排行，直观展示当日最受关注的爆料话题，帮你快速理清吃瓜优先级。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '有据可查',
    desc: '坚持每条爆料附来源依据，拒绝造谣传谣。专业编辑团队严格审核，为你打造干净可靠的吃瓜环境。',
  },
];

export const contactInfo = {
  title: '投稿爆料',
  subtitle: '你有线索，我们有人手',
  desc: '如果你掌握赛事相关的独家信息、内幕线索或一手资料，欢迎通过以下方式联系我们。线索一经采用，将获得专属曝光位与爆料人保护。',
  email: 'tips@meirihei.com',
  tips: ['严格保护爆料人隐私', '线索核实后24小时内发布', '重大爆料可获首页置顶推荐'],
};

export const aboutInfo = {
  title: '关于我们',
  subtitle: '做最有态度的赛事爆料平台',
  content: '每日大赛黑料成立于2024年，由一群热爱赛事文化的资深媒体人创立。我们不止于表面报道，而是深入挖掘每场大赛背后的真实故事与内幕信息。从电竞赛场的BP博弈到选秀节目的票数玄机，从选手私下互动到节目组的幕后操作，我们以专业视角为吃瓜群众还原最真实的赛场内外。平台已累计追踪超过200场大型赛事，发布独家爆料逾5000条，覆盖用户超百万。我们不制造谣言，只做内幕的搬运工——每一条黑料背后，都有一支严苛的事实核查团队在把关。',
};

export const rankings = [
  { rank: 1, title: '某顶流选秀节目票数造假实锤流出，节目组连夜开会应对', heat: '98.7万', tag: '爆', time: '2小时前' },
  { rank: 2, title: '电竞豪门内部矛盾激化，主力选手疑似被冷藏内幕曝光', heat: '86.3万', tag: '热', time: '5小时前' },
  { rank: 3, title: '歌唱大赛评委私下收受好处费，聊天记录截图流出引争议', heat: '74.1万', tag: '热', time: '3小时前' },
  { rank: 4, title: '真人秀节目剧本曝光，所谓随机淘汰环节全为提前设计', heat: '62.8万', tag: '新', time: '8小时前' },
  { rank: 5, title: '某知名选手与经纪公司对簿公堂，千万违约金条款存猫腻', heat: '51.5万', tag: '新', time: '6小时前' },
  { rank: 6, title: '选秀节目导师私下评价选手录音流出，措辞激烈引发争议', heat: '43.2万', tag: '', time: '10小时前' },
  { rank: 7, title: '电竞赛事裁判偏袒争议持续发酵，多名退役选手联名声讨', heat: '38.9万', tag: '', time: '12小时前' },
];

export const cards = [
  {
    img: 'https://readdy.ai/api/search-image?query=dark%20mysterious%20backstage%20of%20a%20talent%20show%20competition%20set%20with%20dramatic%20red%20spotlights%20and%20silhouette%20figures%2C%20cinematic%20lighting%2C%20suspenseful%20atmosphere%2C%20editorial%20photo%20style%2C%20deep%20shadows%2C%20warm%20and%20dark%20tones&width=800&height=500&seq=card-01-2026&orientation=landscape',
    tag: '独家',
    title: '深度揭秘：某选秀节目暗箱操作全流程曝光',
    desc: '从海选内定到决赛控票，业内人士亲述选秀节目背后不可告人的操作规则，涉及多家知名制作公司。',
    time: '3小时前',
    views: '12.8万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=esports%20arena%20behind%20the%20scenes%20with%20gaming%20computers%20and%20tense%20atmosphere%2C%20red%20and%20amber%20ambient%20lighting%2C%20dramatic%20shadows%2C%20competitive%20gaming%20backstage%2C%20editorial%20photography%20style&width=800&height=500&seq=card-02-2026&orientation=landscape',
    tag: '内幕',
    title: '电竞豪门薪资黑幕：顶薪选手真实收入大起底',
    desc: '表面光鲜的电竞明星背后是层层剥削？知情人士披露俱乐部与选手之间的不平等合约与薪资克扣。',
    time: '5小时前',
    views: '9.6万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=dramatic%20stage%20lighting%20in%20a%20singing%20competition%20with%20microphone%20stand%20and%20empty%20judges%20seats%2C%20mysterious%20atmosphere%2C%20red%20and%20dark%20tones%2C%20cinematic%20composition%2C%20editorial%20photography&width=800&height=500&seq=card-03-2026&orientation=landscape',
    tag: '爆料',
    title: '歌唱大赛评委利益输送链：从红包到资源置换',
    desc: '某大型歌唱比赛评委被曝长期收受选手团队好处，录音证据显示点评分数与利益输送直接挂钩。',
    time: '7小时前',
    views: '8.3万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=reality%20TV%20show%20production%20set%20behind%20scenes%20with%20cameras%20and%20crew%20in%20dark%20dramatic%20lighting%2C%20mysterious%20off-camera%20area%2C%20amber%20warm%20tones%2C%20editorial%20style%20photography&width=800&height=500&seq=card-04-2026&orientation=landscape',
    tag: '深挖',
    title: '真人秀剧本工厂：你所看到的冲突全是设计',
    desc: '前节目编剧匿名爆料，解密真人秀从人物设定到冲突编排的完整流程，观众看到的每一帧都在计划之中。',
    time: '9小时前',
    views: '7.1万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=contract%20documents%20on%20a%20dark%20desk%20under%20dramatic%20spotlight%20in%20a%20mysterious%20office%20setting%2C%20warm%20amber%20and%20deep%20shadow%20lighting%2C%20suspenseful%20editorial%20photography%20style%20with%20cinematic%20composition&width=800&height=500&seq=card-05-2026&orientation=landscape',
    tag: '独家',
    title: '选秀选手合约陷阱：违约金条款暗藏百万杀机',
    desc: '多位退赛选手联合披露经纪合约中的霸王条款，看似光鲜的出道机会背后是长达十年的卖身契。',
    time: '11小时前',
    views: '6.5万',
  },
];

export const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20a%20young%20Chinese%20person%20with%20neutral%20expression%2C%20simple%20warm%20background%2C%20headshot%20style%2C%20clean%20lighting&width=120&height=120&seq=avatar-01-2026&orientation=squarish',
    name: '吃瓜一线',
    time: '28分钟前',
    content: '终于有人说了！我追了三季这个选秀，一直觉得票数有问题，每次都是那几个公司的人走到最后，太明显了。',
    likes: '2.3k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20a%20young%20Chinese%20person%20with%20casual%20style%2C%20simple%20warm%20background%2C%20headshot%20style%2C%20clean%20lighting&width=120&height=120&seq=avatar-02-2026&orientation=squarish',
    name: '电竞老炮',
    time: '1小时前',
    content: '电竞圈薪资这块水太深了，我之前就听说某战队主力一个月到手不到合同的一半，中间被抽了多少层都不敢想。',
    likes: '1.8k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20a%20young%20Chinese%20person%20with%20warm%20smile%2C%20simple%20warm%20background%2C%20headshot%20style%2C%20clean%20lighting&width=120&height=120&seq=avatar-03-2026&orientation=squarish',
    name: '娱乐圈观察员',
    time: '2小时前',
    content: '评委收钱这事不是新闻了，但每次看到实锤截图还是觉得离谱，观众花钱投票结果全被内定了。',
    likes: '1.5k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20a%20young%20Chinese%20person%20with%20serious%20look%2C%20simple%20warm%20background%2C%20headshot%20style%2C%20clean%20lighting&width=120&height=120&seq=avatar-04-2026&orientation=squarish',
    name: '真相挖掘机',
    time: '3小时前',
    content: '真人秀剧本这事我最有发言权，以前在节目组实习过，每天开会就是设计冲突和反转，纯纯的工业化生产。',
    likes: '1.2k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20a%20young%20Chinese%20person%20with%20thoughtful%20expression%2C%20simple%20warm%20background%2C%20headshot%20style%2C%20clean%20lighting&width=120&height=120&seq=avatar-05-2026&orientation=squarish',
    name: '路人甲不吃素',
    time: '4小时前',
    content: '合约陷阱这个必须顶上去！好多练习生根本不懂法律，签了就是十年青春，退赛还要赔几百万，太黑了。',
    likes: '986',
  },
];

export const topicIndex = [
  { title: '电竞圈内幕合集', count: '127条', icon: 'ri-gamepad-line', desc: 'LPL、KPL、PEL等赛事相关爆料汇总' },
  { title: '偶像选秀黑料专题', count: '98条', icon: 'ri-star-line', desc: '创造营、青春有你等选秀节目内幕' },
  { title: '歌手竞演深扒', count: '84条', icon: 'ri-mic-line', desc: '我是歌手、中国好声音等节目争议' },
  { title: '真人秀剧本泄露', count: '73条', icon: 'ri-tv-line', desc: '跑男、极挑等真人秀幕后揭秘' },
  { title: '经纪公司黑幕', count: '65条', icon: 'ri-building-line', desc: '各大经纪公司合约与运营内幕' },
  { title: '选手八卦专区', count: '112条', icon: 'ri-user-smile-line', desc: '选手私下恩怨、恋情、纠纷全收录' },
  { title: '裁判争议事件', count: '41条', icon: 'ri-scales-line', desc: '各类赛事裁判不公判决汇总' },
];

export const appEntry = {
  title: '随时随地吃瓜',
  subtitle: '下载每日大赛黑料APP',
  desc: '推送快人一步，离线也能看，独家爆料APP端提前解锁。支持iOS与Android，扫码即刻下载。',
  features: ['实时推送 · 黑料不错过', '独家内容 · APP抢先看', '夜间模式 · 偷偷吃瓜', '爆料上传 · 一键投稿'],
};

export const carouselItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=dark%20dramatic%20scene%20of%20a%20talent%20competition%20stage%20with%20spotlight%20and%20mysterious%20shadow%20figures%2C%20red%20and%20amber%20lighting%2C%20cinematic%20composition%2C%20suspenseful%20atmosphere%2C%20editorial%20photography&width=1200&height=600&seq=carousel-01-2026&orientation=landscape',
    tag: '深度专题',
    title: '选秀产业黑幕白皮书：从资本游戏到粉丝收割',
    desc: '全面盘点近三年选秀节目产业链各环节的灰色操作，涉及平台、制作方、经纪公司与赞助商的多方利益博弈。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=esports%20stadium%20with%20empty%20seats%20and%20dramatic%20stage%20lighting%2C%20dark%20atmosphere%2C%20red%20spotlights%2C%20cinematic%20wide%20shot%2C%20editorial%20photography%20style&width=1200&height=600&seq=carousel-02-2026&orientation=landscape',
    tag: '深度专题',
    title: '电竞选手生存报告：光环背后的残酷真相',
    desc: '从青训营到退役，电竞选手的真实职业生涯远比想象中艰难。伤病、低薪、舆论压力，揭秘光鲜之下的暗面。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=mysterious%20backstage%20corridor%20of%20a%20TV%20studio%20with%20dramatic%20lighting%20and%20long%20shadows%2C%20red%20warning%20light%2C%20cinematic%20suspenseful%20atmosphere%2C%20editorial%20photography&width=1200&height=600&seq=carousel-03-2026&orientation=landscape',
    tag: '深度专题',
    title: '综艺节目剧本产业链：从编剧团队到舆情操控',
    desc: '深度起底综艺节目剧本写作团队的运作模式，以及节目组如何通过舆情引导来操控观众情绪和话题走向。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=dramatic%20scene%20of%20legal%20documents%20and%20contracts%20on%20a%20dark%20desk%20under%20spotlight%2C%20red%20and%20warm%20amber%20tones%2C%20cinematic%20close-up%2C%20suspenseful&width=1200&height=600&seq=carousel-04-2026&orientation=landscape',
    tag: '深度专题',
    title: '娱乐经纪霸王条款大盘点：你的偶像被困在合同里',
    desc: '收集整理各大经纪公司标准合同中的不平等条款，揭示偶像艺人在光鲜外表下承受的合约枷锁与利益剥削。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=anonymous%20whistleblower%20silhouette%20in%20a%20dark%20room%20with%20dramatic%20backlight%2C%20warm%20amber%20glow%2C%20cinematic%20composition%2C%20suspenseful%20editorial%20photography%20with%20deep%20shadows&width=1200&height=600&seq=carousel-05-2026&orientation=landscape',
    tag: '深度专题',
    title: '爆料人保护计划：我们如何守护每一位吹哨人',
    desc: '揭秘每日大赛黑料的信源保护机制，从信息加密到身份脱敏，展示平台如何确保爆料人安全的同时还原真相。',
  },
];

export const mediaItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=dark%20studio%20interview%20setup%20with%20dramatic%20red%20lighting%2C%20empty%20chair%20under%20spotlight%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20documentary%20style%20photography&width=800&height=450&seq=media-01-2026&orientation=landscape',
    title: '独家对话：前选秀节目导演自曝行业内幕',
    duration: '18:24',
    views: '45.6万',
    tag: '独家采访',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=esports%20gaming%20room%20in%20dark%20dramatic%20lighting%20with%20computer%20screens%2C%20red%20ambient%20glow%2C%20mysterious%20atmosphere%2C%20cinematic%20photography%20style%2C%20editorial&width=800&height=450&seq=media-02-2026&orientation=landscape',
    title: '深度调查：电竞俱乐部薪资暗访实录',
    duration: '22:36',
    views: '38.2万',
    tag: '暗访调查',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=dramatic%20courtroom%20or%20legal%20setting%20with%20warm%20amber%20lighting%2C%20documents%20on%20a%20dark%20table%2C%20suspenseful%20cinematic%20composition%2C%20editorial%20photography%20style&width=800&height=450&seq=media-03-2026&orientation=landscape',
    title: '合约解密：选秀选手维权案全程回顾',
    duration: '15:10',
    views: '29.7万',
    tag: '案件追踪',
  },
];

export const faqItems = [
  {
    q: '每日大赛黑料的信息来源可靠吗？',
    a: '我们每条爆料均经过多方交叉验证，确保信息来源真实可靠。编辑团队拥有多年赛事媒体从业经验，对信息可信度有严格把关标准。所有标注"独家"的内容均来自直接信源，标注"综合"的内容则为多渠道信息整合。',
  },
  {
    q: '如何向平台爆料？爆料人身份会被保护吗？',
    a: '你可以通过本站"投稿爆料"板块提交线索。我们建立了完善的爆料人保护机制，所有提交信息经端到端加密处理，编辑团队无权查看爆料人原始身份信息。线索一经采用将获得专属曝光位，重大爆料可获首页置顶。',
  },
  {
    q: '每日大赛黑料覆盖哪些赛事类型？',
    a: '目前主要覆盖四大板块：电竞赛事（LPL、KPL、PEL等）、偶像选秀（创造营、青春有你等）、歌手竞演（我是歌手、中国好声音等）和真人秀综艺（跑男、极挑等），同时持续拓展新的赛事领域。',
  },
  {
    q: '平台内容多久更新一次？',
    a: '我们实行7×24小时滚动更新机制，编辑团队全天候监控全平台信息源。重要爆料在核实后最快15分钟内发布，常规内容每小时更新。每日平均更新量在30-50条之间，重大赛事期间可达100条以上。',
  },
  {
    q: '如果发现不实信息怎么办？',
    a: '每篇文章底部均设有"申诉反馈"入口。如发现信息不实，可通过该入口提交证据材料，我们的编辑团队将在2小时内响应。经核实确认为不实信息的，平台将立即撤稿并发布更正声明，同时追究相关编辑责任。',
  },
];

export const topics = [
  { name: '票数造假', heat: '128.5万', trend: 'up', posts: '3,821' },
  { name: '评委收钱', heat: '96.3万', trend: 'up', posts: '2,456' },
  { name: '合约陷阱', heat: '87.1万', trend: 'hot', posts: '1,982' },
  { name: '剧本曝光', heat: '74.2万', trend: 'up', posts: '2,104' },
  { name: '选手不和', heat: '65.8万', trend: 'up', posts: '1,763' },
  { name: '俱乐部黑幕', heat: '58.4万', trend: 'new', posts: '1,245' },
  { name: '导师争议', heat: '52.1万', trend: 'up', posts: '1,089' },
  { name: '赞助撤资', heat: '43.7万', trend: 'new', posts: '876' },
  { name: '退赛内幕', heat: '39.2万', trend: 'up', posts: '732' },
  { name: '暗箱操作', heat: '35.6万', trend: 'hot', posts: '654' },
  { name: '薪资黑幕', heat: '31.9万', trend: 'up', posts: '598' },
];

export const updates = [
  { time: '14:32', title: '某选秀节目被曝总决赛前三名已提前内定，知情人士提供内部会议记录', tag: '最新' },
  { time: '13:15', title: '电竞豪门与主力选手合约纠纷升级，选手微博发长文控诉不平等待遇', tag: '跟进' },
  { time: '11:48', title: '知名歌唱比赛节目组连夜开会，疑似应对即将曝出的评委受贿丑闻', tag: '独家' },
  { time: '10:20', title: '真人秀节目导演组成员集体辞职，知情人士称与剧本操纵争议有关', tag: '最新' },
  { time: '09:05', title: '选秀练习生联名举报经纪公司，指控包括非法抽成与人身限制', tag: '跟进' },
  { time: '08:30', title: '电竞赛事裁判委员会宣布将对近期争议判罚展开内部调查', tag: '最新' },
  { time: '07:12', title: '某歌唱大赛冠军被曝参赛资格造假，节目组暂未回应媒体询问', tag: '独家' },
  { time: '06:45', title: '综艺节目广告赞助商因丑闻事件考虑撤资，节目命运悬而未决', tag: '跟进' },
  { time: '05:30', title: '深夜重磅：多档选秀节目被指共用同一投票系统后台，数据可被操控', tag: '独家' },
];

export const footerInfo = {
  description: '每日大赛黑料——专注赛事内幕与独家爆料的头部平台。覆盖电竞、选秀、综艺、歌唱等多元赛道，以极速追踪、深度揭秘、有据可查为核心价值，为亿万吃瓜群众提供真实、及时的赛事幕后资讯。',
  sections: {
    quickLinks: [
      { text: '热门排行', href: '#ranking' },
      { text: '独家爆料', href: '#cards' },
      { text: '吃瓜现场', href: '#comments' },
      { text: '常见问题', href: '#faq' },
      { text: '投稿爆料', href: '#contact' },
    ],
    tracks: [
      { text: '电竞内幕', href: '#index' },
      { text: '选秀黑料', href: '#index' },
      { text: '歌手竞演', href: '#index' },
      { text: '真人秀剧本', href: '#index' },
      { text: '经纪公司', href: '#index' },
    ],
  },
};